const FIELD_LABELS = {
	shippingMessage: "Mensagem do cartão",
	shippingSender: "Quem envia",
	shippingRecipient: "Quem recebe",
	shippingDate: "Data da entrega",
	shippingPeriod: "Período da entrega",
	local: "Endereço",
	numero: "Número",
	complemento: "Complemento",
	bairro: "Bairro",
	cidade: "Cidade",
	estado: "Estado",
	CEP: "CEP",
	observation: "Observação",
	nome: "Nome",
	email: "E-mail",
	cpf: "CPF",
};

const translateJoiMessage = (raw) => {
	if (!raw || typeof raw !== "string") return raw;
	const stripped = raw.replace(/^"[^"]+"\s*/, "");
	if (/length must be less than or equal to (\d+) characters long/i.test(stripped)) {
		const max = stripped.match(/(\d+)/)[1];
		return `deve ter no máximo ${max} caracteres`;
	}
	if (/length must be at least (\d+) characters long/i.test(stripped)) {
		const min = stripped.match(/(\d+)/)[1];
		return `deve ter pelo menos ${min} caracteres`;
	}
	if (/is required/i.test(stripped)) return "é obrigatório";
	if (/is not allowed to be empty/i.test(stripped)) return "não pode ficar vazio";
	if (/must be a number/i.test(stripped)) return "deve ser um número";
	if (/must be a valid date/i.test(stripped)) return "deve ser uma data válida";
	return stripped.charAt(0).toLowerCase() + stripped.slice(1);
};

const fieldLabel = (fieldPath) => {
	if (!fieldPath) return "Campo";
	const parts = Array.isArray(fieldPath) ? fieldPath : [fieldPath];
	const key = parts[parts.length - 1];
	return FIELD_LABELS[key] || key;
};

const formatValidationItem = (item) => {
	const label = fieldLabel(item.field);
	const detail = item.messages?.[0] || item.message;
	if (detail) return `${label}: ${translateJoiMessage(detail)}`;
	return `${label}: preencha corretamente`;
};

const errorHandling = (error) => {
	if (!error.response || !error.response.data) {
		return { status: 500, message: "Ocorreu um erro no servidor. Tente novamente." };
	}
	const data = error.response.data;
	const status = error.response.status || 500;
	if (data.status === 401 || status === 401) {
		return { status: 401, message: "Não autorizado." };
	}
	const _errors = data.errors;
	if (_errors) {
		if (typeof _errors === "string") return { status: 400, message: _errors };
		if (Array.isArray(_errors) && _errors.length) {
			const parts = _errors.map(formatValidationItem);
			return { status: 400, message: parts.join(" ") };
		}
	}
	if (typeof data.message === "string" && data.message.length && data.message !== "validation error") {
		return { status, message: data.message };
	}
	if (data.error != null) {
		if (typeof data.error === "string" && data.error !== "validation error") {
			return { status, message: data.error };
		}
		if (typeof data.error === "object" && typeof data.error.message === "string") {
			return { status, message: data.error.message };
		}
	}
	return { status, message: "Ocorreu um erro. Tente novamente." };
};

export default errorHandling;
